module.exports = __webpack_public_path__ + "static/img/planRight2.7fd59ae8.png";